module.exports = __webpack_public_path__ + "img/logo.928055d5.svg";